import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BehfaRole_Interface, Empty_BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleEdit',
  templateUrl: './BehfaRoleEdit.component.html',
  styleUrls: ['./BehfaRoleEdit.component.scss']
})
export class BehfaRoleEditComponent implements OnInit {

  Title:string=""
  Token:String=""
  EditRecord:number
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>Type your text here...</p>'
  };
  public config = {
    language: 'fa'
  };

  constructor(
    private Alertify_Service:AlertifyService,
    private BehfaRole_Service:BehfaRoleService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.Nav_Service.CheckValidPage(this.Token,1105).subscribe(
      data=>{

        this.BehfaRole_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.Title = data.title
            this.model.editorData=data.dsc
          },error=>{
            localStorage.clear()
            location.reload();
          }
        )

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }


  InProccessing:boolean=false
  onSubmitForm(){

    if(!this.Title)
    {
      this.Alertify_Service.ErrorMessage("Please enter a title")
    }
    else{
      var Record:BehfaRole_Interface=Empty_BehfaRole_Interface()
      Record.title=this.Title
      Record.dsc=this.model.editorData
      Record.id=this.EditRecord

      this.InProccessing=true
      this.BehfaRole_Service.EditBehfaRole(Record,this.Token).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.InProccessing=false
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )

    }

  }

}
